module.exports = __webpack_public_path__ + "img/wishCardBg.2390b494.png";